import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
 
  Grid,
  TextField,
 
  Button,
  Autocomplete,
} from "@mui/material";
import { Close, TextFields } from "@mui/icons-material";
import {
  CmpDatePicker,

} from "../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { fAlertToast } from "../../Utility/Utilitys";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  IMPURTrip_POST,
  IMPURTrip_Update,
  PackingUnit_Buyer_getrowsAPI,
} from "../../Server/ApiV2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VerifiedIcon from "@mui/icons-material/Verified";

const TripPlanningDetail = ({
  open,
  onClose,
  selectedRow,
  loadSummary,
  setSelectedRow,
  
}) => {
  const [formData, setFormData] = useState(selectedRow || {});
  const [buyerdata, setBuyerData] = useState([]);

  useEffect(() => {
    if (selectedRow) {
      setFormData({
        ...selectedRow,
        Buyer: selectedRow?.Buyer || "",
      });
    } else if (buyerdata.length > 0) {
      setFormData((prev) => ({
        ...prev,
        Buyer: buyerdata[0]?.UID || "",
      }));
    }
  }, [selectedRow, buyerdata]);

  const [summaryRows, setSummaryRows] = useState([]);
  const [errors, setErrors] = useState({});

  const handleVersionModalClose = () => {
    onClose();
    setFormData({});
    setSummaryRows([]);
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));

    // 🔹 Clear error only for the changed field
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const vRdxUserInfoObj = vRdxUserInfo();

  // ✅ Validation function
  const validateFields = () => {
    let tempError = {};

    if (!formData.Name?.trim()) tempError.Name = "Name should not be empty";

    if (!formData.Buyer) tempError.Buyer = "Buyer Location is required";

    if (moment(formData.Expt_To).isBefore(moment(formData.Expt_From))) {
      tempError.Expt_To = "To Date cannot be earlier than From Date";

      
    }

    setErrors(tempError);
    return Object.keys(tempError).length === 0;
  };

  console.log(formData);

  const fSave = async () => {
    try{
    if (!validateFields()) {
      fAlertToast("ERROR", "Please fill in all required fields!");
      return;
    }

    const obj = {
      TripId: formData.TripId,
      Name: formData.Name,
      Expt_From: moment(formData.Expt_From).format("MM/DD/YYYY"),
      Expt_To: moment(formData.Expt_To).format("MM/DD/YYYY"),
      Buyer: formData.Buyer,
      UserCd: vRdxUserInfoObj?.UserID,
    };

    const result = await IMPURTrip_Update(obj);
    console.log(result);

    if (result?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully!");
      await loadSummary();
      setFormData((prev) => ({
        ...prev,
        TripId: result?.data?.ResultSet[0]?.TripId,
      }));
    }
    } catch (error) {}
  };

  const fPost = async () => {
    try{
    const obj = {
      TripId: formData.TripId,
      UserCd: vRdxUserInfoObj?.UserID,
    };
    const result = await IMPURTrip_POST(obj);
    console.log("result,", result);

    if (result?.status === 200) {
      fAlertToast("SUCCESS", "Post Successfully");
      setFormData((prev) => ({ ...prev }));

      onClose();
      await loadSummary();
    } else {
      fAlertToast("ERROR", "Post Failed");
    }
    } catch (error) {}
  };

  const fBuyer = async () => {
    const result = await PackingUnit_Buyer_getrowsAPI();
    console.log(result);

    if (result?.status === 200) {
      const data = result?.data?.Buyer ?? [];
      setBuyerData(data);
    }
  };
  useEffect(() => {
    fBuyer();
  }, []);

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 450, md: "500px !important" },
        },
      }}
    >
      {" "}
      <Box
     
      >
       
        <Box mt={4}>
          <Box
            sx={{
                                backgroundColor: "#1e88e5 ",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 1,
              py: { xs: 2, sm: 1.2 },
              mt: { xs: "10px", sm: "12px", md:4 },
              
            }}
          >
            
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, marginLeft: "8px" }}
            >
              Trip Detail
            </Typography>

            <IconButton
              onClick={() => {
                onClose();
                setFormData({});
                setErrors({});
                setSelectedRow({});
              }}
              sx={{
                color: "#ffffff",
                backgroundColor: "rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>

       
        <Box sx={{ p: 4, flexGrow: 1, overflowY: "auto" }}>
         
          <VerifiedIcon
  sx={{
    marginLeft: "96%",
    color:
      formData?.Status === "OPEN"
        ? "gold"
        : formData?.Status === "CLOSE"
        ? "green"
        : "grey",
  }}
/>


          <Grid container spacing={3} pt={1} >
           
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Trip ID"
                fullWidth
                size="small"
                disabled
                name="TripId"
                value={formData.TripId}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => handleChange("TripId", e.target.value)}
                autoComplete="off"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    padding: "16px 14px !important",
                  },
                   
                "& .MuiInputLabel-root.Mui-disabled": {
                  color:" #475560 ",
                  fontWeight: 600,
                },
                }}
              />
            </Grid>

          
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label=" Name"
                name="Name"
                fullWidth
                size="small"
                value={formData.Name}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => handleChange("Name", e.target.value)}
                onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setTimeout(() => {
                    document.getElementById("Buyer").focus();
                  }, 200);
                }
              }}
                error={!!errors.Name}
                helperText={errors.Name}
                autoComplete="off"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    padding: "16px 14px !important",
                  },
                  "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Autocomplete
                freeSolo
                id="Buyer"
                label="Buyer"
                name="Buyer"
                disableClearable
                options={buyerdata} // Use full objects
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.Name1
                } // Support free text input
                value={buyerdata.find((buyer) => buyer.UID === formData?.Buyer)}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setFormData((prev) => ({
                      ...prev,
                      Buyer: newValue, // Store typed value
                    }));
                  } else if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      Buyer: newValue.UID, // Store UID when selecting from dropdown
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      Buyer: "", // Store UID when selecting from dropdown
                    }));
                  }
                  
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setFormData((prev) => ({
                      ...prev,
                      Buyer: "",
                    }));
                     setTimeout(() => {
                    document.getElementsByName("Expt_From")[0]?.focus();
                  }, 200);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Buyer"
                    name="Buyer"
                    id="Buyer"
                    error={!!errors.Buyer}
                    helperText={errors.Buyer}
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        type: "search",
                      },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <CmpDatePicker
                style={{ width: "100% !important" }}
                xValue={formData?.Expt_From}
                xOnChange={(newValue) =>{
                   setFormData((prev) => ({
                    ...prev,
                    Expt_From: newValue?.$d ?? newValue,
                  }))
                   setTimeout(() => {
                    document.getElementsByName("Expt_To")[0]?.focus();
                  }, 200);
                }
                 
                  
                }
                xFullWidth
                xLabelText={"Expt_From"}
                xName={"Expt_From"}
                xError={!!errors.Expt_From}
                xErrorMessage={errors.Expt_From}
                
              />
            </Grid>

           
            <Grid item xs={12} sm={12} md={12}>
              <CmpDatePicker
                style={{ width: "100% !important" }}
                xValue={formData?.Expt_To}
                xOnChange={(newValue) => {
                  setFormData((obj) => ({
                    ...obj,
                    Expt_To: newValue.$d,
                  }));
                  setErrors((obj) => ({
                    ...obj,
                    Expt_To: '',
                  }));
                }}
                xName={"Expt_To"}
                xLabelText={"Expt_To"}
                xFullWidth
                xError={!!errors.Expt_To}
                xErrorMessage={errors.Expt_To}
              />
            </Grid>

            
          </Grid>

          <Box
            sx={{
              display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 4,
            }}
          >
            <Button variant="contained" color="primary" onClick={fSave}  
           disabled={formData.Status==="CLOSE"}
            
             >
              Save
            </Button>
            <Button variant="contained" color="success" onClick={fPost}            disabled={formData.Status==="CLOSE"}
>
              Post
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default TripPlanningDetail;



